import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppointmentCase, Service } from '@quorum/models/xs-resource';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'quorum-show-line-item-services-dialog',
  templateUrl: './show-line-item-services-dialog.component.html',
  styleUrls: ['./show-line-item-services-dialog.component.scss'],
})
export class ShowLineItemServicesDialogComponent implements OnInit {
  services$: BehaviorSubject<Service[]> = new BehaviorSubject<Service[]>(this.dialogData.services);
  constructor(
    public dialogRef: MatDialogRef<ShowLineItemServicesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: { case: AppointmentCase; services: Service[] }
  ) {}

  ngOnInit(): void {
    this.services$.next(
      this.dialogData.services.filter((service: Service) => service.name !== this.dialogData.case.requestDescription)
    );
  }

  cancel() {
    this.dialogRef.close();
  }
}
